// extracted by mini-css-extract-plugin
module.exports = {"box":"ArticleRenderer_box_93Wp_"};